import { applyMiddleware, createStore, compose } from "redux";
import { analyticsMiddleware } from "../shared/analyticsManager";
import rootReducer from "./rootReducer";

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (initialState?: any) =>
  createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(analyticsMiddleware))
  );
